import { ChevronRight } from "lucide-react";
import { PRODUCTS } from "@/src/constants/constants";
import type { Product } from "@/src/types";
import { ProductCard } from "./ProductCard";

interface ProductGridProps {
    onAddToCart: (product: Product) => void;
}

export function ProductGrid({ onAddToCart }: ProductGridProps) {
    return (
        <main className="max-w-7xl mx-auto px-6 py-24">
            <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
                <div className="max-w-xl">
                    <h2 className="font-serif text-4xl md:text-5xl mb-6">
                        The Core Collection
                    </h2>
                    <p className="text-stone-500 leading-relaxed font-light">
                        Hand-poured in small batches using premium soy wax and
                        botanical oils. Each scent is a journey through nature's
                        most evocative landscapes.
                    </p>
                </div>
                <button className="flex items-center gap-2 text-sm uppercase tracking-widest border-b border-stone-300 pb-1 hover:border-stone-900 transition-colors">
                    View All <ChevronRight size={16} />
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
                {PRODUCTS.map((product, idx) => (
                    <ProductCard
                        key={product.id}
                        product={product}
                        index={idx}
                        onAddToCart={onAddToCart}
                    />
                ))}
            </div>
        </main>
    );
}
